import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'ppl-form-row',
    templateUrl: './form-row.component.html',
    styleUrls: ['./form-row.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PplFormRowComponent {
}
